// Copyright (C) 2020 Toitware ApS.
// Use of this source code is governed by an MIT-style license that can be
// found in the LICENSE file.

import styled from "@emotion/styled";
import { AppBar } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import { length } from "../../assets/theme";
import Search from "../../containers/header/Search";

const StyledAppBar = styled(AppBar)`
  height: ${({ theme }) => theme.layout.headerHeight};
  left: ${({ theme }) => theme.layout.sidebarWidth};
  width: calc(100% - ${({ theme }) => length(theme.layout.sidebarWidth)});
  border-bottom: 1px solid black;
  background: rgba(255, 255, 255, 0.6);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
`;

export function HeaderBar(): JSX.Element {
  return (
    <StyledAppBar color="default" position="fixed" elevation={0}>
      <Toolbar>
        <Search />
      </Toolbar>
    </StyledAppBar>
  );
}

export default HeaderBar;
